import { Injectable } from '@angular/core';

@Injectable()
export class PanelEvent {
  bufferSpinnerLoading!: any[];
}
